<template>
    <article class="ui-file__wrapper">
        <section
            :class="[
                'u-file',
                { 'u-file--uploading' : !completed },
                { 'u-file--error' : error }
            ]"
        >
            <transition name="fade-in" mode="out-in">
                <div v-if="!completed" class="u-file__progress" :style="`width: ${percentage}%`" />
            </transition>

            <header class="u-file__header">
                <h3 class="u-file__title">
                    <transition name="fade-in" mode="out-in">
                        <span
                            :key="`status-analysing-${percentage === 100}`"
                            :class="[
                                'u-file__status',
                                { 'u-file__status--uploading' : percentage < 100 },
                                { 'u-file__status--analysing' : percentage === 100 },
                                { 'u-file__status--error' : error }
                        ]">
                            {{ statusLabel }}
                        </span>
                    </transition>

                    <transition name="fade-in" mode="out-in">
                        <span class="u-file__title-text">{{ cardName }}</span>
                    </transition>

                    <transition name="fade-in" mode="out-in">
                        <Spinner v-if="percentage === 100 && !error" style="width: 1em; height: 1em; display: inline-block; float: right;" />
                    </transition>
                </h3>
            </header>

            <transition name="fade-in" mode="out-in">
                <section class="u-file__error" v-if="error">
                    <p>{{ error }}</p>
                </section>
            </transition>
        </section>
    </article>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        name: { type: String, required: true },
        completed: { type: Boolean, default: false },
        percentage: { type: [String, Number], default: 0 },
        error: { type: String, default: null },
    },

    computed: {
        cardName () {
            if (this.error) return `Could not upload ${this.name}`
            if (this.percentage === 100) return `Extracting data from ${this.name}`
            return this.name
        },

        statusLabel () {
            if (this.error) return "Error"
            if (this.percentage === 100) return 'Analysing'
            return 'Uploading'
        }
    }
}
</script>

